import type { Transaction } from 'src/apis/capacity-management/types';
import type {
  SurrenderActionForDeal,
  SurrenderActionForTrade,
} from 'src/apis/surrender-service-legacy/types';

/** The CaMa deals and trades returned by the legacy `getDeals` and `getTrades` requests. */
export type LegacySurrenderability = {
  deals: SurrenderActionForDeal[];
  trades: SurrenderActionForTrade[];
};

const toCreateSurrenderPath = (
  item: SurrenderActionForDeal | SurrenderActionForTrade | undefined,
  id: string | undefined
) =>
  item?._links.createSurrenderRequest
    ? `/reporting/surrenders/create/${id}`
    : null;

/** The path to the legacy CaMa surrender wizard, `null` when the transaction is not surrenderable. */
export const getLegacyCreateSurrenderPath = (
  transaction: Transaction,
  { deals, trades }: LegacySurrenderability
): string | null => {
  switch (transaction.transactionType) {
    case 'MULTI_YEAR_TRANSPORT_ALLOCATION':
      return toCreateSurrenderPath(
        deals.find(
          (item) => item.dealId === transaction.transactionTypeSpecificId
        ),
        transaction.entry?.multiYearTransportAllocationId ??
          transaction.exit?.multiYearTransportAllocationId
      );

    case 'AUCTION':
      return toCreateSurrenderPath(
        deals.find((item) => item.dealId === transaction.dealId),
        transaction.entry?.auctionAllocationId ||
          transaction.exit?.auctionAllocationId
      );

    case 'TRANSFER_OF_USE_SELL':
    case 'TRANSFER_OF_USE_BUY':
    case 'ASSIGNMENT_SELL':
    case 'ASSIGNMENT_BUY':
      return toCreateSurrenderPath(
        trades.find((item) => item.tradeId === transaction.tradeId),
        transaction.tradeId
      );

    case 'FCFS':
    case 'DIRECT_FCFS':
    case 'SURRENDER':
    case 'CONVERSION':
    case 'RESHUFFLE':
    case 'RESHUFFLE_FROM':
      return null;
  }
};
